{
  "jira-business-saved-views.admin.changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Saved views are now in timeline view.\n\nSave your view for everyone in the project or reset it back to your previous saved view."
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.headline": [
    {
      "type": 0,
      "value": "Save and reset your timeline view"
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.primary-action": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-business-saved-views.admin.changeboarding.spotlight.secondary-action": [
    {
      "type": 0,
      "value": "More about saved views"
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.body": [
    {
      "type": 0,
      "value": "Saved views are now in timeline view. Your admin set up a view to help make collaboration easier.\n\nYou can make changes to your view or reset to the admin's view anytime."
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.headline": [
    {
      "type": 0,
      "value": "Reset your view"
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.primary-action": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-business-saved-views.changeboarding.spotlight.secondary-action": [
    {
      "type": 0,
      "value": "More about saved views"
    }
  ],
  "jira-software-timeline-m3.descriptionContentBulkOperations": [
    {
      "type": 0,
      "value": "Edit, move, transition, watch or delete multiple work items simultaneously."
    }
  ],
  "jira-software-timeline-m3.descriptionContentCustomizeBar": [
    {
      "type": 0,
      "value": "Make specific work items easier to scan or highlight as a priority."
    }
  ],
  "jira-software-timeline-m3.descriptionContentFindWork": [
    {
      "type": 0,
      "value": "Search, filter and group work items."
    }
  ],
  "jira-software-timeline-m3.descriptionContentSeeSubtasks": [
    {
      "type": 0,
      "value": "They now appear under epics."
    }
  ],
  "jira-software-timeline-m3.headingContentBulkOperations": [
    {
      "type": 0,
      "value": "Reduce repetitive work"
    }
  ],
  "jira-software-timeline-m3.headingContentCustomizeBar": [
    {
      "type": 0,
      "value": "Customize bars using colors"
    }
  ],
  "jira-software-timeline-m3.headingContentFindWork": [
    {
      "type": 0,
      "value": "Quickly find work items"
    }
  ],
  "jira-software-timeline-m3.headingContentSeeSubtasks": [
    {
      "type": 0,
      "value": "See subtasks at a glance"
    }
  ],
  "jira-software-timeline-m3.modal.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-software-timeline-m3.modal.doneButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-software-timeline-m3.modal.nextButton": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-software-timeline-m3.timelineImprovmentsLink": [
    {
      "type": 0,
      "value": "Read about Timeline improvements."
    }
  ],
  "post-office.software-timeline-example-message-template.example-placement.cta-button.no-translate": [
    {
      "type": 0,
      "value": "Try now"
    }
  ],
  "post-office.software-timeline-testing.dismiss-button.no-translate": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "post-office.software-timeline-testing.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Placements v2"
    }
  ],
  "post-office.software-timeline-testing.test-message.dismiss-button.no-translate": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-10k-issues-flag.actions": [
    {
      "type": 0,
      "value": "Learn more about the 10k limit"
    }
  ],
  "timeline-10k-issues-flag.description": [
    {
      "type": 0,
      "value": "Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."
    }
  ],
  "timeline-10k-issues-flag.title": [
    {
      "type": 0,
      "value": "This space has more than 10k work items."
    }
  ],
  "timeline-feedback-collector.spotlight.body": [
    {
      "type": 0,
      "value": "In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don’t want."
    }
  ],
  "timeline-feedback-collector.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "timeline-feedback-collector.spotlight.give-feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "timeline-feedback-collector.spotlight.heading": [
    {
      "type": 0,
      "value": "We’re updating Jira timelines"
    }
  ]
}